import { createReducer, on } from '@ngrx/store';
import * as PropertyActions from './property.actions';
import { GroupedPropertiesResponse } from '../../models/property-section.model';

export interface PropertyState {
  properties: any[];
  property: any | null;
  groupedProperties: GroupedPropertiesResponse | null;
  loading: boolean;
  error: any | null;
}

export const initialState: PropertyState = {
  properties: [],
  property: null,
  groupedProperties: null,
  loading: false,
  error: null,
};

export const propertyReducer = createReducer(
  initialState,

  // Load Grouped Properties
  on(PropertyActions.loadGroupedProperties, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(PropertyActions.loadGroupedPropertiesSuccess, (state, { groupedProperties }) => ({
    ...state,
    groupedProperties,
    loading: false,
  })),
  on(PropertyActions.loadGroupedPropertiesFailure, (state, { error }) => ({
    ...state,
    error,
    loading: false,
  })),

  // Load Properties
  on(PropertyActions.loadProperties, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(PropertyActions.loadPropertiesSuccess, (state, { properties }) => ({
    ...state,
    properties,
    loading: false,
  })),
  on(PropertyActions.loadPropertiesFailure, (state, { error }) => ({
    ...state,
    error,
    loading: false,
  })),

  // Load Property
  on(PropertyActions.loadProperty, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(PropertyActions.loadPropertySuccess, (state, { property }) => ({
    ...state,
    property,
    loading: false,
  })),
  on(PropertyActions.loadPropertyFailure, (state, { error }) => ({
    ...state,
    error,
    loading: false,
  })),

  // Create Property
  on(PropertyActions.createProperty, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(PropertyActions.createPropertySuccess, (state, { property }) => ({
    ...state,
    properties: [...state.properties, property],
    loading: false,
  })),
  on(PropertyActions.createPropertyFailure, (state, { error }) => ({
    ...state,
    error,
    loading: false,
  })),

  // Update Property
  on(PropertyActions.updateProperty, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(PropertyActions.updatePropertySuccess, (state, { property }) => ({
    ...state,
    properties: state.properties.map((p) => (p.id === property.id ? property : p)),
    property: property,
    loading: false,
  })),
  on(PropertyActions.updatePropertyFailure, (state, { error }) => ({
    ...state,
    error,
    loading: false,
  })),

  // Delete Property
  on(PropertyActions.deleteProperty, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(PropertyActions.deletePropertySuccess, (state, { id }) => ({
    ...state,
    properties: state.properties.filter((p) => p.id !== id),
    loading: false,
  })),
  on(PropertyActions.deletePropertyFailure, (state, { error }) => ({
    ...state,
    error,
    loading: false,
  }))
);
